import { useTranslations } from 'hooks/useTranslations'
import { configurationsService } from 'shared/services/ConfigurationsService'
import { PublicationType } from 'hooks/usePublications'
import { useStaticSWR } from './useStaticSWR'
import { useLanguage } from 'store/locale/hooks/useLanguage'
import axios from 'axios'

interface IYearsProps {
  publicationType: PublicationType
  tag?: string
  withPlaceHolder?: boolean
}

export interface IYear {
  code: string
  name: string
}

const defaultYears = (): IYear[] => {
  const MIN_YEAR = 2000
  return Array.from(Array(new Date().getFullYear() - MIN_YEAR + 1), (x, index) => ({
    code: (MIN_YEAR + index).toString(),
    name: (MIN_YEAR + index).toString()
  })).reverse()
}

const extractYears = (data: any) =>
  data
    ? data
        .map((year) => ({
          code: year.toString(),
          name: year.toString()
        }))
        .reverse()
    : defaultYears()

const fetcher = (url: string, language: string, tag: string = 'all') =>
  axios
    .get(url, {
      params: {
        tag,
        language
      }
    })
    .then((result) => result.data)

export const useYears = ({ publicationType, tag = 'all', withPlaceHolder }: IYearsProps) => {
  const url =
    publicationType === PublicationType.News
      ? configurationsService.newsItemsYearsEndpoint
      : configurationsService.getYearsPublicationEndpoint(publicationType)
  const { language } = useLanguage()
  const t = useTranslations()
  const { data } = useStaticSWR({ key: [url, language, tag], fetcher })

  const years = extractYears(data)

  const placeholder: IYear = {
    code: 'all',
    name: t('select-year')
  }

  return withPlaceHolder ? [placeholder, ...years] : years
}
